import { StatTiles } from '@parsina/framework';

/**
 * The 4-up stat row — the mobile design's one glanceable header block.
 *
 * Deliberately `StatTiles` and neither of the two things a screen would
 * otherwise reach for:
 *
 *   • `KpiCard` carries a 140px minimum width, so four of them wrap into a
 *     2x2 grid. That doubles the vertical cost of the numbers and pushes the
 *     day's list below the fold, which is the one thing a reception cockpit
 *     cannot afford.
 *   • `StatsBar` scrolls horizontally. A strip may scroll when it is a
 *     navigation strip the operator drives; a row of four numbers that must be
 *     read in ONE sweep may not, because a number you have to scroll to find
 *     is a number you do not glance at.
 *
 * The kit's grid is `repeat(N, minmax(0, 1fr))` so a long value COMPRESSES.
 * With a plain `1fr` the track's automatic minimum width would push the row
 * past 320px and take the whole page into horizontal scroll.
 *
 * Values arrive pre-formatted: the digit seam belongs to the app (Persian
 * digits, money in toman), not to the kit. A missing value renders «—» so the
 * row is always N-up and the tiles never re-flow as data lands.
 */
export default function MobileStatTiles({ tiles, loading, columns = 4, style, 'data-testid': testId }) {
  return (
    <div style={{ paddingInline: '1rem', ...style }} data-testid={testId}>
      <StatTiles tiles={tiles} loading={loading} columns={columns} />
    </div>
  );
}
